import React, { useEffect, useState } from 'react'
import Form from 'react-bootstrap/Form';
import { Link, useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import loginimg from '../../Assets/Images/signup.png'
import logo from '../../Assets/Images/Caduceus 512x512.gif'
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { toast } from 'react-toastify'
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { USER_BASE_URL, SignUp } from '../../API';

function Registration() {
    const { register, handleSubmit, formState: { errors }, setValue, watch } = useForm();
    const navigate = useNavigate();
    const watchpassword = watch('password')
    const [showPassword, setShowPassword] = useState(false);
    const [showPassword1, setShowPassword1] = useState(false);

    const togglePasswordVisibility = () => { setShowPassword(!showPassword) };
    const togglePasswordVisibility1 = () => { setShowPassword1(!showPassword1) };

    useEffect(() => {
        const storedEmail = localStorage.getItem("email");
        const storedPassword = localStorage.getItem("password");
        setValue('email', storedEmail);
        setValue('password', storedPassword);
    }, [])

    const submitHandler = async (data) => {
        data.language = "ENGLISH"
        try {
            const res = await axios.post(USER_BASE_URL + SignUp, data);
            if (res.status === 200) navigate('/otp', { state: { data: data?.email } })
        }
        catch (error) {
            let err = ''
            if (error.response.data.error_message) { err = error.response.data.error_message; }
            else { err = error.response.data.error_description }
            console.log(error)
            toast.error(err)
        }
    }
    return (
        <section className="login-section">
            <div className="container-fluid g-0">
                {/* <Header /> */}
                <Row className='row-min-h'>
                    <Col lg={6} className="img-n">
                        <div className="upper-fig-main-login">
                            <figure className="login-img-main">
                                <img src={loginimg} alt="" className="img-fluid" />
                            </figure>
                        </div>
                    </Col>
                    <Col lg={6} >
                        <div className="inner-login-mian">
                            <div className="loginupper-right">
                                <figure className='creden_page_logo'>
                                    <img src={logo} alt="" className='img-fluid' />
                                </figure>
                                <h2>Sign up</h2>
                                <p className='auth_page_sub_heading'>Create your account and get started today!</p>
                                <Form onSubmit={handleSubmit(submitHandler)}>
                                    <Row>
                                        <Col md={12}>
                                            <Form.Group controlId="formGridName" className="comn-class-inputs">
                                                <Form.Label>Name</Form.Label>
                                                <Form.Control
                                                    type="text" autoFocus
                                                    placeholder="Enter Your Name"
                                                    {...register("full_name", {
                                                        required: "Please enter name.",
                                                        validate: (value) => {
                                                            const trimmed = value.trim();
                                                            if (!trimmed) return "Name cannot be empty or just spaces.";
                                                            if (trimmed.length < 3) return "Name must be at least 3 characters long.";
                                                            return true;
                                                        }
                                                    })}
                                                />
                                                {errors.full_name && (
                                                    <span className="error">{errors.full_name.message}</span>
                                                )}
                                            </Form.Group>
                                        </Col>

                                        <Col md={12}>
                                            <Form.Group controlId="formGridEmail" className="comn-class-inputs">
                                                <Form.Label>Email</Form.Label>
                                                <Form.Control
                                                    type="email"
                                                    placeholder="Enter Your Email"
                                                    {...register("email", {
                                                        required: true,
                                                        pattern: {
                                                            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                                            message: "Please enter a valid email.",
                                                        },
                                                    })}
                                                />
                                                {errors.email && <span className="error">{errors.email.message || "Please enter email."}</span>}
                                            </Form.Group>
                                        </Col>

                                        <Col md={12}>
                                            <Form.Group controlId="formGridAddress" className="comn-class-inputs">
                                                <Form.Label>Address</Form.Label>
                                                <Form.Control
                                                    type="text" autoFocus
                                                    placeholder="Enter Your Address"
                                                    {...register("address", {
                                                        required: "Please enter address.",
                                                        validate: (value) => {
                                                            const trimmed = value.trim();
                                                            if (!trimmed) return "Address cannot be empty or just spaces.";
                                                            if (trimmed.length < 3) return "Address must be at least 3 characters long.";
                                                            return true;
                                                        }
                                                    })}
                                                />
                                                {errors.address && (<span className="error">{errors.address.message}</span>)}
                                            </Form.Group>
                                        </Col>

                                        <Col md={12}>
                                            <Form.Group controlId="formGridPhone" className="comn-class-inputs">
                                                <Form.Label>Phone number</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    placeholder="Enter Your Phone Number"
                                                    {...register("number", {
                                                        required: true,
                                                        pattern: {
                                                            value: /^[0-9]{8,12}$/,
                                                            message: "Phone number should be between 8 to 12 digits.",
                                                        },
                                                    })}
                                                    onKeyDown={(e) => {
                                                        if (!/[0-9]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Tab' && e.key == 'e') {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                />

                                                {errors.number && <span className="error">{errors.number.message || "Please enter phone number."}</span>}
                                            </Form.Group>
                                        </Col>

                                        <Col md={12}>
                                            <Form.Group controlId="formGridPassword" className="comn-class-inputs">
                                                <Form.Label>Password</Form.Label>
                                                <div className="cstPassGroup">
                                                    <Form.Control
                                                        type={showPassword ? "text" : "password"}
                                                        placeholder="Enter Your Password"
                                                        {...register("password", {
                                                            required: true,
                                                            pattern: {
                                                                value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?#&_])[A-Za-z\d@$!%*?#&_]{8,}$/,
                                                                message: "Password must be at least 8 characters long with uppercase, lowercase, number, special character, and no spaces.",
                                                            },
                                                        })}
                                                    />
                                                    <div onClick={togglePasswordVisibility} className="eyeToggleBtn">
                                                        {showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                                                    </div>
                                                </div>
                                                {errors.password && <span className="error">{errors.password.message || "Please enter password."}</span>}
                                            </Form.Group>
                                        </Col>

                                        <Col md={12}>
                                            <Form.Group controlId="formGridConfirmPassword" className="comn-class-inputs">
                                                <Form.Label>Confirm password</Form.Label>
                                                <div className="cstPassGroup">
                                                    <Form.Control
                                                        type={showPassword1 ? "text" : "password"}
                                                        placeholder="Confirm Password"
                                                        {...register("confirm_password", {
                                                            required: "Please enter confirm password.",
                                                            validate: value => value === watchpassword || 'Password and confirm password must be the same.'
                                                        })}
                                                    />
                                                    <div onClick={togglePasswordVisibility1} className="eyeToggleBtn">
                                                        {showPassword1 ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                                                    </div>
                                                </div>
                                                {errors.confirm_password && <span className="error">{errors.confirm_password.message}</span>}
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <div className="have_read_checkout_checkbox">
                                        <Form.Group className="custom-checkbox">
                                            <input id="checkbox2" type="checkbox"
                                                {...register('termsConditions', {
                                                    required: 'You must accept the Terms and Conditions and Privacy Policy to continue.'
                                                })}
                                            />
                                            <label htmlFor="checkbox2" >
                                                <div className="d-flex flex-wrap">
                                                    <p>I agree to the
                                                        <Link to="/terms-conditions"> Terms and Conditions</Link>
                                                        and
                                                        <Link to="/privacy-policy">Privacy Policy</Link>
                                                    </p>
                                                </div>
                                            </label>
                                        </Form.Group>
                                        {errors.termsConditions && (<span className='error'>{errors.termsConditions.message}</span>)}
                                    </div>
                                    <Button className='login-btn' type="submit">Create Account</Button>
                                </Form>
                                <div className="auth-bottom-link-sec">
                                    <p>Already have an account? <Link to="/login"> Login</Link></p>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </section >
    )
}
export default Registration;                                                                                                                                                                                                                                                                                                                                                                